import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@mui/material';

export const Avatar = MuiAvatar;
export type AvatarProps = MuiAvatarProps;
